<template>
	<div class="ui segment">
		<h2 class="ui header">星座运势</h2>

		<div class="m-padded-tb-small">
			<el-radio-group v-model="channel" size="small">
				<el-radio-button label="xx">小小运势</el-radio-button>
				<el-radio-button label="vmy">维梦运势</el-radio-button>
			</el-radio-group>
		</div>

		<div class="m-padded-tb-small">
			<!-- 小小运势 -->
			<div v-if="channel === 'xx'">
				<el-form :model="xx" label-width="80px" class="m-form">
					<el-form-item label="选择星座">
						<el-select v-model="xx.type" placeholder="选择星座" filterable clearable>
							<el-option v-for="item in zodiacList" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择时间">
						<el-select v-model="xx.time" placeholder="选择时间">
							<el-option label="今日" value="today"></el-option>
							<el-option label="本周" value="week"></el-option>
							<el-option label="本月" value="month"></el-option>
							<el-option label="本年" value="year"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>

			<!-- 维梦运势 -->
			<div v-else>
				<el-form :model="vmy" label-width="80px" class="m-form">
					<el-form-item label="选择星座">
						<el-select v-model="vmy.msg" placeholder="选择星座" filterable clearable>
							<el-option v-for="name in chineseZodiac" :key="name" :label="name" :value="name"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div style="margin-top:12px;">
				<el-button type="primary" @click="fetchHoroscope" :loading="loading">查询</el-button>
				<el-button @click="clearResult" style="margin-left:8px;">清空</el-button>
			</div>
		</div>

		<div v-if="resultObj" class="m-padded-tb-small">
			<div class="ui segment">
				<h4 class="ui header">查询结果 - {{ resultObj.title || resultObj.type || '' }}</h4>

				<div class="horoscope-meta">
					<div class="type">{{ resultObj.type }}</div>
					<div class="time">{{ resultObj.time }}</div>
					<div class="name">{{ resultObj.title || resultObj.name }}</div>
				</div>

				<div class="horoscope-short" v-if="resultObj.shortcomment">{{ resultObj.shortcomment }}</div>

				<div class="horoscope-scores" v-if="resultObj.fortune">
					<div class="score-item" v-for="(v,k) in resultObj.fortune" :key="k">
						<div class="label">{{ labelMap[k] || k }}</div>
						<div class="bar"><div class="bar-inner" :style="{width: (Number(v) / 5 * 100) + '%'}"></div></div>
						<div class="score">{{ v }}/5</div>
					</div>
				</div>

				<div class="horoscope-index" v-if="resultObj.index">
					<div class="score-item" v-for="(v,k) in resultObj.index" :key="k">
						<div class="label">{{ labelMap[k] || k }}</div>
						<div class="score">{{ v }}</div>
					</div>
				</div>

				<div class="horoscope-texts" v-if="resultObj.fortunetext">
					<p v-if="resultObj.fortunetext.all"><strong>{{ labelMap.all }}：</strong>{{ resultObj.fortunetext.all }}</p>
					<p v-if="resultObj.fortunetext.health"><strong>{{ labelMap.health }}：</strong>{{ resultObj.fortunetext.health }}</p>
					<p v-if="resultObj.fortunetext.love"><strong>{{ labelMap.love }}：</strong>{{ resultObj.fortunetext.love }}</p>
					<p v-if="resultObj.fortunetext.money"><strong>{{ labelMap.money }}：</strong>{{ resultObj.fortunetext.money }}</p>
					<p v-if="resultObj.fortunetext.work"><strong>{{ labelMap.work }}：</strong>{{ resultObj.fortunetext.work }}</p>
				</div>

				<div class="horoscope-todo" v-if="resultObj && resultObj.todo">
					<div><strong>宜：</strong>{{ resultObj.todo.yi }}</div>
					<div><strong>忌：</strong>{{ resultObj.todo.ji }}</div>
				</div>

			</div>
		</div>
		<!-- 维梦返回纯文本，按行解析展示 -->
		<div v-else-if="resultRaw && channel === 'vmy'" class="m-padded-tb-small">
			<div class="ui segment">
				<h4 class="ui header">查询结果</h4>
				<div class="vmy-result">
					<div v-for="(line, idx) in parsedVmyLines" :key="idx" class="vmy-line">
						<span class="vmy-key" v-if="line.k">{{ line.k }}：</span><span class="vmy-val">{{ line.v }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'Horoscope',
	data() {
		return {
			channel: 'xx',
			loading: false,
			// 查询结果对象（优先使用 resultObj 展示），保留原始字符串用于调试
			resultObj: null,
			resultRaw: '',
			xx: {
				type: '',
				time: 'today'
			},
			vmy: {
				msg: ''
			},
			zodiacList: [
				{ label: '白羊座(Aries)', value: 'aries' },
				{ label: '金牛座(Taurus)', value: 'taurus' },
				{ label: '双子座(Gemini)', value: 'gemini' },
				{ label: '巨蟹座(Cancer)', value: 'cancer' },
				{ label: '狮子座(Leo)', value: 'leo' },
				{ label: '处女座(Virgo)', value: 'virgo' },
				{ label: '天秤座(Libra)', value: 'libra' },
				{ label: '天蝎座(Scorpio)', value: 'scorpio' },
				{ label: '射手座(Sagittarius)', value: 'sagittarius' },
				{ label: '摩羯座(Capricorn)', value: 'capricorn' },
				{ label: '水瓶座(Aquarius)', value: 'aquarius' },
				{ label: '双鱼座(Pisces)', value: 'pisces' }
			],
			chineseZodiac: [
				'白羊座', '金牛座', '双子座', '巨蟹座', '狮子座', '处女座',
				'天秤座', '天蝎座', '射手座', '摩羯座', '水瓶座', '双鱼座'
			]
		}
	},
	computed: {
		labelMap() {
			return {
				all: '总体运势',
				health: '健康运势',
				love: '爱情运势',
				money: '财富运势',
				work: '工作运势'
			}
		},
		parsedVmyLines() {
			if (!this.resultRaw) return []
			const lines = this.resultRaw.split(/\r?\n/).map(l => l.trim()).filter(Boolean)
			return lines.map(line => {
				const parts = line.split(/[:：]/)
				if (parts.length > 1) {
					const key = parts.shift().trim()
					const value = parts.join(':').trim()
					return { k: key, v: value }
				}
				return { k: '', v: line }
			})
		}
	},
	watch: {
		channel() {
			this.clearResult()
		}
	},
	methods: {
		clearResult() {
			this.resultObj = null
			this.resultRaw = ''
		},
		async fetchHoroscope() {
			this.resultObj = null
			this.resultRaw = ''
			if (this.channel === 'xx') {
				if (!this.xx.type) {
					this.$message.warning('请选择星座')
					return
				}
				if (!this.xx.time) {
					this.$message.warning('请选择时间')
					return
				}
				this.loading = true
				try {
					const resp = await axios.get('https://v2.xxapi.cn/api/horoscope', {
						params: {
							type: this.xx.type,
							time: this.xx.time
						}
					})
					// 保存原始返回用于调试
					this.resultRaw = JSON.stringify(resp.data, null, 2)
					// 小小运势数据位于 resp.data.data
					this.resultObj = resp.data && resp.data.data ? resp.data.data : resp.data
				} catch (err) {
					this.$message.error('请求失败: ' + (err.message || err))
				} finally {
					this.loading = false
				}
			} else {
				if (!this.vmy.msg) {
					this.$message.warning('请选择星座')
					return
				}
				this.loading = true
				try {
					// 维梦接口不支持跨域，必须走同源代理：
					// 开发环境由 vue.config.js 的 devServer.proxy['/vmy'] 转发；
					// 生产环境需在 nginx 配置相同的 /vmy 反向代理（见项目 README/部署说明）
					const resp = await axios.get('/vmy/wl/s/xingzuo', {
						params: {msg: this.vmy.msg}
					})
					this.resultRaw = typeof resp.data === 'string' ? resp.data : JSON.stringify(resp.data, null, 2)
					this.resultObj = null
				} catch (err) {
					this.$message.error('请求失败: ' + (err.message || err))
				} finally {
					this.loading = false
				}
			}
		}
	}
}
</script>

<style scoped>
.m-form {
	max-width: 520px;
}
.m-padded-tb-small {
	margin-top: 12px;
	margin-bottom: 12px;
}
.horoscope-meta {
	display:flex;
	align-items:center;
	gap:12px;
	margin-bottom:8px;
}
.horoscope-meta .type {
	background:#f2f6ff;
	color:#2a63d8;
	padding:4px 8px;
	border-radius:4px;
	font-weight:600;
}
.horoscope-meta .time {
	color:#888;
	font-size:12px;
}
.horoscope-short {
	color:#444;
	margin-top:6px;
}
.horoscope-scores{
	display:flex;
	flex-wrap:wrap;
	gap:8px;
	margin:12px 0;
}
.score-item{
	flex:1 1 140px;
	background:#fafafa;
	padding:8px;
	border-radius:6px;
	border:1px solid #f0f0f0;
}
.score-item .label{
	text-transform:capitalize;
	font-size:12px;
	color:#666;
	margin-bottom:6px;
}
.bar{
	background:#eee;
	height:8px;
	border-radius:4px;
	overflow:hidden;
}
.bar-inner{
	height:100%;
	background:linear-gradient(90deg,#ffd54d,#ff8a65);
}
.score{
	text-align:right;
	font-size:12px;
	color:#444;
	margin-top:6px;
}
.horoscope-texts p{
	margin:8px 0;
	line-height:1.6;
}
.horoscope-index{
	display:flex;
	gap:12px;
	margin-top:10px;
	flex-wrap:wrap;
}
.horoscope-todo{
	margin-top:10px;
	font-size:14px;
}
.vmy-result{
	padding:6px 4px;
	line-height:1.7;
}
.vmy-line{
	padding:6px 0;
	border-bottom:1px dashed #eee;
}
.vmy-key{
	font-weight:700;
	margin-right:6px;
}
.vmy-val{
	color:#333;
}
</style>


